import { render, staticRenderFns } from "./appDownload.vue?vue&type=template&id=d40f2d06&"
import script from "./appDownload.vue?vue&type=script&lang=js&"
export * from "./appDownload.vue?vue&type=script&lang=js&"
import style0 from "./appDownload.vue?vue&type=style&index=0&id=d40f2d06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports